// apps/landing-page/src/components/Analytics.tsx
'use client';

import Script from 'next/script';
import { useAnalyticsConsent } from '@/lib/use-consent';

/**
 * Google Analytics 4: dependency-free, env-driven, and opt-in.
 *
 * Renders nothing until NEXT_PUBLIC_GA_ID is set to a real measurement ID
 * (the `.env.example` placeholder `G-XXXXXXXXXX` is treated as "not set") AND the
 * visitor has accepted analytics cookies (see lib/consent.ts). Revoking later stops
 * new loads but cannot unload gtag from the page already open; it is gone on the next load.
 * To enable: set NEXT_PUBLIC_GA_ID=G-XXXXXXXXXX in this app's env and rebuild.
 */
export function Analytics() {
  const hasConsent = useAnalyticsConsent();
  const gaId = process.env.NEXT_PUBLIC_GA_ID;
  if (!hasConsent || !gaId || gaId === 'G-XXXXXXXXXX') return null;

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        strategy="afterInteractive"
      />
      <Script id="ga4-init" strategy="afterInteractive">
        {`window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${gaId}');`}
      </Script>
    </>
  );
}
